(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.image
   * @description
   *
   */
  angular
  .module('neo.home.entitats.entitat.informacio.image', []);
}());
